import { Component, inject } from '@angular/core';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { OrderService } from '@api-services';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { map } from 'rxjs/operators';

@Component({
  selector: 'wun-bo-order-detail',
  standalone: true,
  imports: [CurrencyPipe, DatePipe, RouterLink],
  templateUrl: './order-detail.component.html',
  styleUrl: './order-detail.component.scss'
})
export class OrderDetailComponent {

  private readonly orderService = inject(OrderService);
  private readonly route = inject(ActivatedRoute);

  private readonly id = toSignal(this.route.params.pipe(map(p => Number(p['orderId']))));

  order = rxResource({
    params: this.id,
    stream: params => this.orderService.ordersGetById({
      id: params.params,
      includes: JSON.stringify(['rows.artwork.mainAttachment', 'rows.artwork.artist', 'user', 'payment'])
    })
  });

  statusLabel(status: string): string {
    const map: Record<string, string> = {
      CREATED: 'In attesa',
      PAYED: 'Pagato',
      SHIPPED: 'Spedito',
      DELIVERED: 'Consegnato',
    };
    return map[status] ?? status;
  }

  statusClass(status: string): string {
    const map: Record<string, string> = {
      CREATED: 'bg-yellow-100 text-yellow-800',
      PAYED: 'bg-blue-100 text-blue-800',
      SHIPPED: 'bg-purple-100 text-purple-800',
      DELIVERED: 'bg-green-100 text-green-800',
    };
    return map[status] ?? 'bg-gray-100 text-gray-800';
  }
}
